/**
 * Frontend-Script für stwkiss/news-loop Block
 * Initialisiert Swiper für Slider-Instanzen
 */

import './style.scss';

document.addEventListener('DOMContentLoaded', () => {
    // Nur initialisieren wenn Swiper global verfügbar ist
    if (typeof Swiper === 'undefined') {
        console.warn('Swiper ist nicht geladen. Slider werden nicht initialisiert.');
        return;
    }

    // Alle Slider-Instanzen finden
    const sliders = document.querySelectorAll('.wp-block-stwkiss-news-loop.is-slider');

    sliders.forEach((sliderBlock) => {
        const blockId = sliderBlock.id;
        if (!blockId) return;

        // Swiper-Container innerhalb des Blocks
        const swiperElement = sliderBlock.querySelector(`.swiper-${blockId}`);
        if (!swiperElement) return;

        // Attribute aus data-* lesen (falls gesetzt) oder Defaults
        const slidesPerView = parseInt(
            sliderBlock.dataset.slidesPerView || '3',
            10
        );

        // Swiper initialisieren
        new Swiper(swiperElement, {
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: `.swiper-button-next-${blockId}`,
                prevEl: `.swiper-button-prev-${blockId}`,
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                },
                782: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                1200: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },

                1280: {
                    slidesPerView: slidesPerView,
                    spaceBetween: 30,
                },
            },
            // Accessibility
            a11y: {
                enabled: true,
                slideRole: 'listitem',
                prevSlideMessage: 'Vorheriger Slide',
                nextSlideMessage: 'Nächster Slide',
                firstSlideMessage: 'Dies ist der erste Slide',
                lastSlideMessage: 'Dies ist der letzte Slide',
            },
        });
    });
});
